export default "78ebe9b046e6e894.svg"